import cn from "classnames";

import { Text, type TextProps } from "@/components/text/text.component";

export function MonitoringPlanSlotTitle({
  title,
  titleBold,
  titleRegular,
  variant = "h4",
  component = "h3",
  className,
}: MonitoringPlanSlotTitleProps) {
  const bold = titleBold?.trim();
  const regular = titleRegular?.trim();
  const useSplit = Boolean(bold || regular);

  if (!useSplit) {
    return (
      <Text
        variant={variant}
        component={component}
        className={cn("font-bold", className)}>
        {title}
      </Text>
    );
  }

  return (
    <Text
      variant={variant}
      component={component}
      className={cn("font-normal", className)}>
      {bold ? <span className="font-bold">{bold}</span> : null}
      {bold && regular ? " " : null}
      {regular ? <span className="font-normal">{regular}</span> : null}
    </Text>
  );
}

type MonitoringPlanSlotTitleProps = {
  title: string | null | undefined;
  titleBold?: string | null;
  titleRegular?: string | null;
  variant?: TextProps["variant"];
  component?: TextProps["component"];
  className?: string;
};
